import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, renderSlot as _renderSlot, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"


const __default__ = {
  inheritAttrs: false,
};

import {
  computed,
  useSlots,
  ref,
  PropType,
  ComputedRef,
} from 'vue';
import OpenSeadragon from 'openseadragon';

import { useGetAnnotationQuery, useUpdateAnnotationMutation } from '@/entities/annotation/hooks';

import { Annotation } from '@/entities/annotation/types';
import { OverlayEventMap } from '@/core/components/data-display/OSD/osd.shared';

import { NkButton, NkCenter, NkOSDOverlay, NkContextMenu } from '@/core/components';
import { StOSDOverlayBackground } from '@/core/components/data-display/OSD/osd.styled';
import store from "@/store";


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'InspectionViewerAnnotation',
  props: {
  index: {
    type: Number,
    default: 0,
  },
  annotation: {
    type: Number as PropType<Annotation['id']>,
    required: true,
  },
  active: {
    type: Boolean,
    default: false,
  },
  highlight: {
    type: Boolean,
    default: false,
  },
  contextMenuOptions: {
    type: Object,
    default: () => ({
      placement: 'right-start',
    }),
  },
},
  emits: ['click', 'focusin', 'focusout', 'mouseenter', 'mouseleave'],
  setup(__props, { emit }) {

const props = __props


// z-[0], z-[1], z-[2],z-[3],z-[4],z-[5],z-[6],z-[7],z-[8],z-[9],z-[10]z-[11],z-[12],z-[13],z-[14],z-[15],z-[16],z-[17],z-[18],z-[19],z-[20]





const slots = useSlots();
const { mutateAsync: updateAnnotation } = useUpdateAnnotationMutation();

const isZoomed = ref(false);
const isContextMenuActive = computed(() => !!(slots?.['context-menu']) && !!(slots?.['context-menu']()?.length));

const getAnnotationQueryData = computed(() => ({ id: props.annotation }));
const hasAnnotation = computed(() => !!annotation.value);
const { data: annotation } = useGetAnnotationQuery(getAnnotationQueryData);
const position: ComputedRef<Annotation['position'] | undefined> = computed(() => annotation.value?.position);

const overlayOptions = computed(() => {
  if (position.value) {
    return new OpenSeadragon.Rect(position.value.viewportX, position.value.viewportY, position.value.viewportWidth, position.value.viewportHeight);
  }

  return null;
});

const updatePosition = (event: Parameters<OverlayEventMap['update']>[0]) => {
  if (annotation.value && position.value) {
    updateAnnotation({
      ...annotation.value,
      position: {
        ...annotation.value.position,
        viewportX: event.x,
        viewportY: event.y,
        viewportWidth: event.width,
        viewportHeight: event.height,
        pixelX: Math.round(event.pixelX),
        pixelY: Math.round(event.pixelY),
        pixelWidth: Math.round(event.pixelWidth),
        pixelHeight: Math.round(event.pixelHeight),
      } as Annotation['position'],
    });
  }
};

const onZoom = (zoomValue: number | undefined) => {
  if (zoomValue) {
    isZoomed.value = zoomValue >= 1.5;
  }

  return false;
};

return (_ctx: any,_cache: any) => {
  return (_unref(hasAnnotation) && _unref(overlayOptions))
    ? (_openBlock(), _createBlock(_unref(NkOSDOverlay), _mergeProps({
        key: 0,
        highlight: props.highlight,
        active: __props.active,
        options: {
        location: _unref(overlayOptions),
      },
        resizable: ""
      }, _ctx.$attrs, {
        onClick: _cache[0] || (_cache[0] = (e) => emit('click', e)),
        onFocusin: _cache[1] || (_cache[1] = (e) => emit('focusin', e)),
        onFocusout: _cache[2] || (_cache[2] = (e) => emit('focusout', e)),
        onUpdate: _cache[3] || (_cache[3] = (e) => updatePosition(e))
      }), {
        default: _withCtx(() => [
          _createVNode(_unref(NkContextMenu), {
            active: _unref(isContextMenuActive),
            options: {
          ...props.contextMenuOptions,
        }
          }, {
            content: _withCtx(({hide}) => [
              _renderSlot(_ctx.$slots, "context-menu", { hide: hide })
            ]),
            default: _withCtx(() => [
              _createVNode(_unref(StOSDOverlayBackground), {
                "is-highlight": props.highlight,
                active: props.active,
                class: _normalizeClass([{ 'is-zoomed': isZoomed.value }, "w-full h-full"]),
                service: _ctx.$store.getters['service/service']
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NkCenter), { class: "h-full overflow-hidden" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NkButton), {
                        circle: "",
                        class: "pointer-events-none",
                        icon: "NkComment"
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["is-highlight", "active", "class", "service"])
            ]),
            _: 3
          }, 8, ["active", "options"])
        ]),
        _: 3
      }, 16, ["highlight", "active", "options"]))
    : _createCommentVNode("", true)
}
}

})